import { getConfig } from './getConfig';
import cookie from './cookie';

const {
  sites: { mweb, desktop },
  actionPaths: { login, authorize },
} = getConfig();

export default (isDesktop: boolean) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('Please set your "access_token" cookie according to your enviroment');
    if (cookie.get('access_token')) {
      cookie.remove('access_token');
      window.location.reload();
    }
    return;
  }

  if (process.env.NODE_ENV === 'production') {
    const { domain, url } = isDesktop ? desktop : mweb;
    const currentLocation = encodeURIComponent(window.location.href);

    if (isDesktop) {
      const redirectBackParam = `?ref[0][params][url]=${currentLocation}&ref[0][action]=redirector&ref[0][method]=index`;
      window.location.href = url + authorize + redirectBackParam;
    } else {
      /*
       * TODO: Remove the auth token cleaning after resolving:
       * https://naspersclassifieds.atlassian.net/browse/A2B-972
       */
      cookie.remove('access_token', `.${domain}`);
      cookie.remove('refresh_token', `.${domain}`);

      const redirectBackParam = `?redirectTo=${currentLocation}`;
      window.location.href = url + login + redirectBackParam;
    }
  }
};
